<!-- Header -->
@if (filteredRoutesLoaded && !isLogoutPage) {
<div>
  <np-header>
    <!-- Logged in user info -->
    <div class="header-user-info d-none d-sm-block">
      <div class="user-text-info">
        <div class="header-username">{{ loggedUsername }}</div>
        @if (userRoles.length > 0) {
        <div class="header-roles small text-muted">
          @for (role of userRoles; track role; let last = $last) {
          <span>
            {{ role }}@if (!last) {
            <span>,&nbsp;</span>
            }
          </span>
          }
        </div>
        }
      </div>
      <div class="logout-container">
        <button mat-icon-button class="logout-btn" (click)="logout()" aria-label="Logout" title="Logout">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
    </div>
  </np-header>
</div>
}

<!-- Site-Specific Navigation -->
@if (filteredRoutesLoaded && !isLogoutPage) {
<div>
  <np-menu [location]="NavigationLocation.SiteSpecific"></np-menu>
</div>
}

@if (dataLoading && !isLogoutPage) {
  <app-shell-skeleton></app-shell-skeleton>
}

<!-- Main Content -->
@if (!dataLoading || isLogoutPage) {
<router-outlet></router-outlet>
}

<!-- AI Chat Assistant -->
@if (!dataLoading && !isLogoutPage && isOnAssessmentPage) {
<app-chat-container [trackedBusinessApplicationId]="currentAssessmentId"></app-chat-container>
}

@if (!dataLoading && !isLogoutPage) {
<footer>
  <ul>
    <li>&copy; 2026 Chevron Corporation</li>
    <li>Company Confidential</li>
    <li>Technical contact: AMORE (ARM) Team</li>
  </ul>
</footer>
}

<!-- Version Display -->
@if (!dataLoading && !isLogoutPage) {
<div class="text-muted small"
  style="text-align: center; padding: 10px 0; background-color: #f8f9fa; border-top: 1px solid #dee2e6;">
  Version: {{ appVersion || 'Loading...' }}
</div>
}